import { useBreadcrumb } from "features/breadcrumbs";
import ListaArrecadacoes from "./components/ListaArrecadacoes";
import Container from 'components/Container';

function ArrecadaoListagemPages() {
  useBreadcrumb([
    { name: "Financeiro" },
    { name: "Receita" },
    { name: "Arrecadações" },
  ]);

  return (
    <Container pb="32px">
      <ListaArrecadacoes />
    </Container>
  );
}

export default ArrecadaoListagemPages;
